import React from 'react'

export function Loader() {
  return (
    <>
      <div className='lds-ellipsis'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </>
  )
}
